import { Link } from "react-router-dom";
import { Cloud, Mail, MapPin, Phone, Linkedin, Github, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative border-t border-border/60 bg-background overflow-hidden">
      <div className="absolute inset-0 bg-aurora opacity-40 pointer-events-none animate-aurora" aria-hidden />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" aria-hidden />

      <div className="container relative mx-auto px-4 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 space-y-5">
            <Link to="/" className="inline-flex items-center gap-2 font-heading font-semibold text-lg">
              <Cloud className="h-6 w-6 text-primary" />
              <span>Cloud<span className="text-gradient">ease</span></span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Enterprise cloud infrastructure engineered for growth. From migration to 24/7 operations — we ship reliability at scale.
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/cloudease-inc" },
                { icon: Github, label: "GitHub", href: "https://github.com/cloudeaseinc" },
                { icon: Twitter, label: "X", href: "https://x.com/cloudeaseinc" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="h-9 w-9 rounded-full glass flex items-center justify-center hover:border-primary/40 hover:text-primary transition-colors"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-4">Platform</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/services#cloudops" className="text-foreground/80 hover:text-foreground transition-colors">CloudOps</Link></li>
              <li><Link to="/services#devops" className="text-foreground/80 hover:text-foreground transition-colors">DevOps</Link></li>
              <li><Link to="/services#kubernetes" className="text-foreground/80 hover:text-foreground transition-colors">Kubernetes</Link></li>
              <li><Link to="/services#ai-agents" className="text-foreground/80 hover:text-foreground transition-colors">AI Agents</Link></li>
              <li><Link to="/services#migration" className="text-foreground/80 hover:text-foreground transition-colors">Migration</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-foreground/80 hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/case-studies" className="text-foreground/80 hover:text-foreground transition-colors">Customers</Link></li>
              <li><Link to="/blog" className="text-foreground/80 hover:text-foreground transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-foreground/80 hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4 space-y-3">
            <h4 className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-4">Get in touch</h4>
            <a href="mailto:hello@cloudease.in" className="flex items-center gap-2 text-sm text-foreground/80 hover:text-foreground transition-colors">
              <Mail className="h-4 w-4 text-primary" /> hello@cloudease.in
            </a>
            <a href="tel:+918778730675" className="flex items-center gap-2 text-sm text-foreground/80 hover:text-foreground transition-colors">
              <Phone className="h-4 w-4 text-primary" /> +91 87787 30675
            </a>
            <p className="flex items-start gap-2 text-sm text-muted-foreground">
              <MapPin className="h-4 w-4 text-primary mt-0.5" /> Bengaluru, India
            </p>
            <div className="pt-3 flex items-center gap-2 text-xs font-mono text-muted-foreground">
              <span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse-glow" />
              All systems operational
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border/60 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Cloudease Technologies. Engineered in Bengaluru.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/security" className="hover:text-foreground transition-colors">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
